import React, { FunctionComponent } from 'react';
import styles from './ApplicationCard.module.scss';
import { Block, Button, Card, Icon, ResponsiveImage, Typography } from 'components/elements';
import { WPAcfCard } from 'types/acf/card';
import clsx from 'clsx';
import { Polygon as PolygonIcon } from 'assets/icons';

interface OwnProps {
  data: WPAcfCard | null;
}

type ApplicationCardProps = JSX.IntrinsicElements['div'] & OwnProps;

const ApplicationCard: FunctionComponent<ApplicationCardProps> = props => {
  const { data: cardData } = props;

  if (!cardData) {
    return null;
  }

  const { buttonLabel, buttonLink, image, note, title } = cardData;

  const noteClassNames = clsx({
    [styles.note]: true,
  });

  const titleClassNames = clsx({
    [styles.title]: true,
  });

  return (
    <Block id="application-card" theme="white" data-module="application-card">
      <Card>
        <div className={styles.wrapper}>
          {image && (
            <ResponsiveImage
              className={styles.image}
              desktopImage={{ config: image, imgProps: { componentHeight: true } }}
              mobileImage={{ config: image, imgProps: { componentHeight: true } }}
            />
          )}
          {note && (
            <Typography as="div" align="center" mobile="new_ibm_regular_16" className={noteClassNames}>
              {note}
            </Typography>
          )}
          {title && (
            <Typography as="div" mobile="neue_semibold_20" className={titleClassNames}>
              <span>
                <Icon size={26} icon={PolygonIcon} />
                {title}
              </span>
            </Typography>
          )}
          {buttonLink && buttonLabel && (
            <Button href={buttonLink} as="a" target="_blank">
              {buttonLabel}
            </Button>
          )}
        </div>
      </Card>
    </Block>
  );
};

export default ApplicationCard;
